export default __webpack_public_path__ + "src/assets/images/logo_2.png";